<template>
  <ServicePageLayout
    icon="fas fa-info-circle"
    title="About NC OSAS"
    subtitle="Office of Student Affairs and Services"
  >
    <section
      id="about-sas"
      class="content-section"
    >
      <h2>
        <i class="fas fa-building section-icon" />
        About Student Affairs & Services (SAS)
      </h2>
      <p>
        The Office of Student Affairs and Services (OSAS) is the primary department responsible
        for the holistic development and welfare of students at Northeastern College. We are
        committed to providing comprehensive support services that enhance the overall student
        experience and foster personal growth, academic success, and career readiness.
      </p>
      <p class="mt-1">
        OSAS serves as the bridge between students and the institution, ensuring that every
        student has access to the resources, guidance, and support they need to thrive in their
        academic journey and beyond.
      </p>
    </section>

    <section
      id="purpose-vision"
      class="content-section"
    >
      <h2>
        <i class="fas fa-bullseye section-icon" />
        Purpose & Vision
      </h2>
      <div class="vision-grid">
        <div class="vision-card">
          <div class="card-icon green">
            <i class="fas fa-crosshairs" />
          </div>
          <h3>Our Mission</h3>
          <p>
            The Student Affairs Office of Northeastern College upholds the following mission as governed by the Commission on Higher Education and the learning institution where it belongs.
          </p><hr>
          A.Empower student organizations and leaders through provision of trainings and activities that would develop their full potential;
          <br>
          B. Establish an open relationship to the NC student community to provide an avenue for their suggestions and grievances;
          <br>
          C. Endorse students concerns to the respective department or office for the proper treatment;
          <br>
          D. Supervise the maintenance of safety practices in all establishments that concerns the students.
        </div>
        <div class="vision-card">
          <div class="card-icon yellow">
            <i class="fas fa-eye" />
          </div>
          <h3>Our Vision</h3>
          <p>
            The Northeastern College Student affairs office envisioned to serve as an eye of the institution which looks after the holistic involvement and development of students to affairs promulgated for them.
          </p>
        </div>
        <div class="vision-card">
          <div class="card-icon green">
            <i class="fas fa-heart" />
          </div>
          <h3>Core Values</h3>
          <p>
            Integrity, Service Excellence, Student-Centeredness, Inclusivity, Innovation, and
            Continuous Improvement.
          </p>
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-flag section-icon" />
        Our Goals
      </h2>
      <ul class="goals-list">
        <li>
          <i class="fas fa-check-circle" />
          Ensure student welfare through comprehensive support services
        </li>
        <li>
          <i class="fas fa-check-circle" />
          Develop student leaders through training and organizational activities
        </li>
        <li>
          <i class="fas fa-check-circle" />
          Promote physical and mental health wellness among students
        </li>
        <li>
          <i class="fas fa-check-circle" />
          Foster community engagement and social responsibility
        </li>
        <li>
          <i class="fas fa-check-circle" />
          Provide career guidance and job placement assistance
        </li>
      </ul>
    </section>

    <section
      id="policy-reference"
      class="content-section"
    >
      <h2>
        <i class="fas fa-gavel section-icon" />
        Policy Reference
      </h2>
      <p>
        The Office of Student Affairs and Services operates in accordance with the policies
        set forth by the Commission on Higher Education (CHED) and institutional guidelines.
        Key policy references include:
      </p>
      <div class="policy-list">
        <div class="policy-item">
          <i class="fas fa-file-alt" />
          <div>
            <strong>CHED Memorandum Order No. 9, Series of 2013</strong>
            <p>Enhanced Policies and Guidelines on Student Affairs and Services</p>
          </div>
        </div>
        <div class="policy-item">
          <i class="fas fa-file-alt" />
          <div>
            <strong>Student Handbook</strong>
            <p>Comprehensive guide on student rights, responsibilities, and conduct</p>
          </div>
        </div>
        <div class="policy-item">
          <i class="fas fa-file-alt" />
          <div>
            <strong>Data Privacy Policy</strong>
            <p>Protection and handling of student information in compliance with RA 10173</p>
          </div>
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-sitemap section-icon" />
        Organizational Structure
      </h2>
      <div class="org-structure">
        <div class="org-card director">
          <div class="org-icon">
            <i class="fas fa-user-tie" />
          </div>
          <h4>Director, Student Affairs</h4>
          <p>Overall supervision of SAS programs and services</p>
        </div>
        <div class="org-row">
          <div class="org-card">
            <div class="org-icon small">
              <i class="fas fa-hands-helping" />
            </div>
            <h4>Student Welfare Unit</h4>
          </div>
          <div class="org-card">
            <div class="org-icon small">
              <i class="fas fa-users" />
            </div>
            <h4>Student Development Unit</h4>
          </div>
          <div class="org-card">
            <div class="org-icon small">
              <i class="fas fa-heartbeat" />
            </div>
            <h4>Health Services Unit</h4>
          </div>
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-phone section-icon" />
        Contact OSAS
      </h2>
      <div class="contact-info">
        <div class="contact-item">
          <i class="fas fa-map-marker-alt" />
          <span>2nd Floor, Administration Building, Northeastern College</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-phone" />
          <span>(078) 123-4567 Local 200</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-envelope" />
          <span>osas@nec.edu.ph</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-clock" />
          <span>Monday - Friday, 8:00 AM - 5:00 PM</span>
        </div>
      </div>
    </section>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/landing/ServicePageLayout.vue'

export default {
  name: 'AboutPage',

  components: {
    ServicePageLayout
  },

  metaInfo: () => ({
    title: 'About NC OSAS'
  })
}
</script>

<!-- <style scoped>
/* Page-specific styles only */
.org-structure {
  text-align: center;
}

.org-card {
  display: inline-block;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  margin-bottom: 1rem;
}

.org-card.director {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(251, 191, 36, 0.1) 100%);
  border-color: rgba(16, 185, 129, 0.3);
}

.org-icon {
  width: 48px;
  height: 48px;
  background: #10b981;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  margin: 0 auto 1rem;
}

.org-icon.small {
  width: 40px;
  height: 40px;
  font-size: 1rem;
}

.org-card h4 {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e3a2f;
  margin: 0 0 0.25rem;
}

.org-card p {
  font-size: 0.75rem;
  color: #64748b;
  margin: 0;
}

.org-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}
</style> -->
